module.exports = __webpack_public_path__ + "static/media/camera.d4c946a4.svg";